import { useUpdateItemQuantity } from 'hooks';
import Icon from 'components/shared/icon';
import Image from 'components/shared/image';
import { useSettings } from 'contexts/SettingContext';
import BackInStockNotifier from 'components/pages/product/backInStockNotifier';
import { useEffect, useState } from 'react';
import { useGlobalModules } from 'contexts';
import styles from './outOfStockPopup.module.scss';

const OutOfStockPopup = ({ lineItems, closeModal, locale, cart, startCheckout }) => {
  const updateItemQuantity = useUpdateItemQuantity();
  const { removeProduct } = useSettings();
  const GIDs = lineItems?.map(({ node }) => node?.merchandise?.id);
  const [showContinue, setShowContinue] = useState(false);
  const globalModules = useGlobalModules();
  const { message, buttonContinueCheckoutText } = globalModules.translations.oosCartPopup;
  const {
    content: oosContent,
    success: oosSuccess,
    submit: oosSubmit,
  } = globalModules.translations.oos;

  if (lineItems?.length) {
    document.body.style.overflow = 'hidden';
  }

  const getNewQuantity = (id, difference) => {
    const currentQuantity =
      cart.lines?.edges?.find(item => item.node.merchandise.id === id)?.node?.quantity || 0;

    let newQuantity = currentQuantity - difference;
    if (newQuantity < 0) newQuantity = 0;

    return newQuantity;
  };

  const getFreeItemsQuantity = (relatedProducts, mainProductQuantityDifference) => {
    if (!relatedProducts) return [];
    const parsedRelatedProducts = JSON.parse(relatedProducts);

    const newFreeItems = parsedRelatedProducts.map(id => ({
      variantId: id,
      quantity: getNewQuantity(id, mainProductQuantityDifference),
    }));

    return newFreeItems;
  };

  const handleRemoveLineItems = async items => {
    const newItemsWithQuantity = items.reduce((acc, { node: item }) => {
      acc.push({
        id: item.id,
        variantId: item?.merchandise?.id,
        quantity: 0,
      });

      const relatedProducts = item?.merchandise?.product?.relatedProducts?.value;
      if (relatedProducts) {
        acc.push(...getFreeItemsQuantity(relatedProducts, item?.quantity));
      }

      return acc;
    }, []);

    items.forEach(({ node: item }) => {
      removeProduct(item?.merchandise?.product?.id);
    });

    await updateItemQuantity(newItemsWithQuantity);
  };

  const handleClose = () => {
    document.body.style.overflow = '';
    closeModal();
  };

  useEffect(() => {
    // if there are other lineItems in the card, show continue button
    const otherLineItems = cart?.lines?.edges?.filter(
      item =>
        !lineItems?.find(({ node }) => node?.merchandise?.id === item?.node?.merchandise?.id) &&
        !item?.node?.merchandise?.product?.tags?.includes('free-item')
    );

    if (otherLineItems?.length) {
      setShowContinue(true);
    }
    if (lineItems.length) {
      handleRemoveLineItems(lineItems);
    }
  }, [lineItems]);

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <button
          type="button"
          className={styles.closeBtn}
          onClick={() => {
            handleClose();
          }}
        >
          <Icon type="close" />
        </button>
        <div className={styles.message}>{message}</div>
        <div className={styles.lineItems}>
          {lineItems?.map(lineItem => (
            <div className={styles.productInfo}>
              <div className={styles.itemImage}>
                <Image src={lineItem?.node?.merchandise?.image} layout="fill" />
              </div>
              <span className={styles.productTitle}>
                {lineItem?.node?.merchandise?.product?.title}
              </span>
            </div>
          ))}
        </div>
        <BackInStockNotifier
          locale={locale}
          text={oosContent.json}
          successText={oosSuccess}
          submitText={oosSubmit}
          productIds={GIDs}
          className={styles.notifier}
        />

        <div className={styles.buttons}>
          {showContinue && (
            <button type="button" className={styles.buttonBlack} onClick={() => startCheckout()}>
              {buttonContinueCheckoutText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OutOfStockPopup;
